import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SelectGridComponent } from './select-grid.component';

@NgModule({
  declarations: [SelectGridComponent],
  exports: [SelectGridComponent],
  entryComponents: [SelectGridComponent],
  imports: [CommonModule, TranslateModule]
})
export class SelectGridModule {}

export { SelectGridComponent };

export * from './select-grid.types';
